export const GET_FEEDBACK_REQUEST = 'GET_FEEDBACK_REQUEST';
export const GET_FEEDBACK_SUCCESS = 'GET_FEEDBACK_SUCCESS';
export const GET_FEEDBACK_FAILED = 'GET_FEEDBACK_FAILED';

export const REMOVE_FEEDBACK_REQUEST = 'REMOVE_FEEDBACK_REQUEST';
export const REMOVE_FEEDBACK_SUCCESS = 'REMOVE_FEEDBACK_SUCCESS';
export const REMOVE_FEEDBACK_FAILED = 'REMOVE_EXPLORE_FAILED';

export const getFeedBack = (data) => {
  return { type: GET_FEEDBACK_REQUEST, payload: data };
};

export const removeFeedBack = (data) => {
  return { type: REMOVE_FEEDBACK_REQUEST, payload: data };
};
